export default __webpack_public_path__ + "icon-people.png";